export default __webpack_public_path__ + "static/media/icon-country.225e04ce.svg";